module.exports = __webpack_public_path__ + "static/assets/d56ddfd1d7d4f8394fe03dde4d0f243f.svg";